import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';

// --------------------------------------------
// Registering Syncfusion license key
// --------------------------------------------
registerLicense('NRAiBiAaIQQuGjN/V0Z+XU9EaFtFVmJLYVB3WmpQdldgdVRMZVVbQX9PIiBoS35RdEVnW3lccHBWRWRUVUJ2');

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
};


function isDeployedHost(): boolean {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }
  const host = window.location.hostname;
  return /(?:^|\.)forensicnotes\.com$/i.test(host)
    || /(?:^|\.)azurestaticapps\.net$/i.test(host);
}

function unregisterDevServiceWorkers(): Promise<void> {
  // Leftover workers on ng serve cache old main.js (ZIP ?password=).
  if (environment.production && isDeployedHost()) {
    return Promise.resolve();
  }
  if (typeof navigator === 'undefined' || !navigator.serviceWorker) {
    return Promise.resolve();
  }
  return navigator.serviceWorker.getRegistrations()
    .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    .then(() => {
      if (typeof caches === 'undefined' || !caches.keys) {
        return;
      }
      return caches.keys().then((keys) =>
        Promise.all(keys.map((k) => caches.delete(k)))
      );
    })
    .then(() => undefined)
    .catch(() => undefined);
}

unregisterDevServiceWorkers().then(() => {
  if (document.readyState === 'complete') {
    bootstrap();
  } else {
    document.addEventListener('DOMContentLoaded', bootstrap);
  }
});


// ---------------------------------------------------------------------
// Console output <-- SILENCE on Production
// Suppress ALL console channels (log/info/debug/warn/error), not just log.
// Sensitive data (bearer tokens, encryption keys, decrypted evidence) must
// never reach DevTools. console.error was previously left live, leaking
// tokens in prod. See SECURITY-AUDIT-2026-07.md (CR-1).
// ---------------------------------------------------------------------
if (environment.hideConsoleLog) {
  // check if window exists, if you render backend window will not be available
  if (window) {
    const noop = function () { };
    window.console.log = noop;
    window.console.info = noop;
    window.console.debug = noop;
    window.console.warn = noop;
    window.console.error = noop;
  }
} 